import React from "react";

import { useIntl } from "react-intl";

import CustomFieldDataType from "@mapmycustomers/shared/enum/CustomFieldDataType";
import { Labeled } from "@mapmycustomers/ui";

import ButtonGroup from "@app/component/input/ButtonGroup";
import { getCustomFieldDataTypeDisplayName, getCustomFieldDataTypeImage } from "@app/util/ui";

interface Props {
  editing?: boolean;
  onChange?: (value: CustomFieldDataType) => void;
  value?: CustomFieldDataType;
}

const CustomFieldTypes: React.FC<Props> = ({ editing, onChange, value }) => {
  const intl = useIntl();

  return (
    <Labeled
      label={intl.formatMessage({
        id: "settings.customFields.createEditPane.basicInfo.selectFieldType",
        defaultMessage: "Select field type",
        description: "Settings Custom field - create/edit - basic info Select field type",
      })}
    >
      <ButtonGroup<CustomFieldDataType> disabled={editing} onChange={onChange} value={value}>
        {[
          CustomFieldDataType.TEXT,
          CustomFieldDataType.LARGE_TEXT,
          CustomFieldDataType.DECIMAL,
          CustomFieldDataType.MONETARY,
          CustomFieldDataType.MULTI_OPTION,
          CustomFieldDataType.SINGLE_OPTION,
          CustomFieldDataType.PHONE,
          CustomFieldDataType.DATE,
          CustomFieldDataType.TIME,
          CustomFieldDataType.ADDRESS,
        ].map((type) => (
          <ButtonGroup.Item<CustomFieldDataType>
            icon={<img alt={type} src={getCustomFieldDataTypeImage(type)} />}
            key={type}
            title={getCustomFieldDataTypeDisplayName(intl, type)}
            value={type}
          />
        ))}
      </ButtonGroup>
    </Labeled>
  );
};

export default CustomFieldTypes;
